import React, { useEffect, useState } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import OwlCarousel from "react-owl-carousel";
import threedIcon from "asset/image/3dIcon.png";
// import PropTypes from "prop-types";
import "./Style.css";
import ZoomControls from "component/ZoomControls/ZoomControls";

const ProductImages = ({ listofimage, three3d, flag3dImage, imageALT }) => {
  // console.log('.....Images', listofimage);
  const [border, setBorder] = useState(0);
  const [indeximg, setIndeximg] = useState("0");
  const [slidecount, setSlideCount] = useState("5");
  // const [updatedimages, setUpdatedImages] = useState(listofimage);

  const setDisplayImage = async (index) => {
    setIndeximg(index);
  };
  const handleImage3d = () => {
    three3d(true);
  };
  useEffect(() => {
    if (window.innerWidth <= 480) {
      setSlideCount("2");
    } else if (window.innerWidth <= 768) {
      setSlideCount("3");
    } else {
      setSlideCount("4");
    }
  }, [window.innerWidth]);
  // useEffect(() => {
  // }, [listofimage]);

  return (
    <>
      {listofimage && listofimage.length > 0 ? (
        <div
          className="product-slider-container"
          style={{ backgroundColor: "#FFF", position: "relative" }}
        >
          <div className="fluid">
            <div className="fluid__image-container">
              {flag3dImage && (
                <div
                  onClick={(e) => handleImage3d(e)}
                  className="product-label label-hot pointerimg"
                >
                  <img
                    src={threedIcon}
                    alt={imageALT}
                    width={31}
                    height={31}
                    loading="lazy"
                  />
                </div>
              )}
              <TransformWrapper
                minScale={1}
                maxScale={2}
                disablePadding
                centerZoomedOut
                smooth
                doubleClick={{ disabled: true }}
              >
                <ZoomControls />
                <TransformComponent>
                  <img
                    className="main_image"
                    src={
                      (listofimage && listofimage[indeximg]?.url) ||
                      "/assets/images/Product_Detail_Placeholder.png"
                    }
                    alt={imageALT}
                    width={425}
                    height={420}
                  />
                </TransformComponent>
              </TransformWrapper>
            </div>
          </div>
        </div>
      ) : (
        <div className="product-item">
          <img
            className="product-single-image"
            src="/assets/images/Product_Detail_Placeholder.png"
            width={425}
            height={420}
            alt="products"
          />
        </div>
      )}
      <div className="small-img-detail">
        <OwlCarousel
          items={slidecount}
          // loop
          nav={false}
          // dots={false}
          slideBy={1}
          className="prod-thumbnail owl-dots"
        >
          {listofimage &&
            listofimage.map((imageUrl, i) => (
              <div key={i} className="owl-dot multiple-images">
                <img
                  className={
                    border === i
                      ? "fixed-height-sub active-img"
                      : "fixed-height-sub "
                  }
                  src={imageUrl.url}
                  width={425}
                  height={500}
                  alt="product-thumbnail"
                  style={{ minWidth: 80, minHeight: 90, border: "none" }}
                  onClick={(e) => setDisplayImage(i)}
                />
              </div>
            ))}
        </OwlCarousel>
      </div>
    </>
  );
};
// ProductImages.propTypes = {
//   // listofimage: PropTypes.array,
//   three3d: PropTypes.string,
//   flag3dImage: PropTypes.bool.isRequired,
//   // trade: PropTypes.object.isRequired,
// };

export default ProductImages;
